import { FC, ReactNode } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useApplyPlatformSettingShortcodes } from 'src/utils/usePlatformSettingDisplayText'

interface InfoTooltipProps {
  message: string | ReactNode
  sourceChannelName?: string | null
}

const InfoTooltip: FC<InfoTooltipProps> = ({
  message = '',
  sourceChannelName,
}) => {
  const formatSettingDisplayText = useApplyPlatformSettingShortcodes(sourceChannelName)

  const processedMessage =
    typeof message === 'string' ? formatSettingDisplayText(message) : message

  return (
    <OverlayTrigger
      overlay={
        <Tooltip 
          style={{
            fontSize: '12px',
            minWidth: '320px',
            maxWidth: '640px',
            whiteSpace: 'normal',
          }}>
          {typeof processedMessage === 'string' ? (
            <span dangerouslySetInnerHTML={{ __html: processedMessage }} />
          ) : (
            processedMessage
          )}
        </Tooltip>
      }
    >
      <i className="bi bi-info-circle text-dark fs-5"></i>
    </OverlayTrigger>
  )
}

export default InfoTooltip
